import React from "react"
import Button from "../../../components/button/button"
import Image from "../../../components/image/image"

const Partner = ({ blok }) => (
  <div className="partner gs_reveal">
    {/* Logo */}
    {blok.content.Logo && (
      <Image
        blok={{
          image: blok.content.Logo,
          max_height: blok.content.logo_height,
          max_width: blok.content.logo_width,
        }}
      />
    )}

    <div className="partner__bottom">  
      {/* Login Link */}
      {(blok.content.login_link.id || blok.content.login_link.url) && (
        <Button
          blok={{
            Style: "secondary",
            Label: "Login",
            content_target: blok.content.login_link,
          }}
        />
      )}
    </div>
  </div>
)

export default Partner
